import { IntlShape } from 'react-intl';

import { EntityType, Role } from './types';

type Id =
  | 'userManagement.brandOwner'
  | 'userManagement.enterpriseOwner'
  | 'userManagement.merchantOwner'
  | 'userManagement.venueManager'
  | 'userManagement.venueManagerDescription'
  | 'userManagement.venueManagerDescriptionRetail'
  | 'userManagement.venueManagerRetail'
  | 'userManagement.venueWorker'
  | 'userManagement.venueWorkerDescription'
  | 'userManagement.venueWorkerDescriptionRetail'
  | 'userManagement.venueWorkerRetail';

type Option = {
  id: Id;
  value: Role;
  intl: IntlShape;
};

const createOption = ({ id, value, intl }: Option) => ({
  label: intl.formatMessage({ id }),
  value,
});

export const getUserRoleOptions = (entityType: EntityType, isRetailContext: boolean, intl: IntlShape) => {
  switch (entityType) {
    case 'venue':
      return [
        createOption({
          intl,
          id: isRetailContext ? 'userManagement.venueWorkerRetail' : 'userManagement.venueWorker',
          value: 'venue_worker',
        }),
        createOption({
          intl,
          id: isRetailContext ? 'userManagement.venueManagerRetail' : 'userManagement.venueManager',
          value: 'venue_manager',
        }),
      ];
    case 'merchant':
      return [
        createOption({
          intl,
          id: 'userManagement.merchantOwner',
          value: 'merchant_owner',
        }),
      ];
    case 'enterprise':
      return [
        createOption({
          intl,
          id: 'userManagement.enterpriseOwner',
          value: 'enterprise_owner',
        }),
      ];
    case 'brand':
      return [
        createOption({
          intl,
          id: 'userManagement.brandOwner',
          value: 'brand_owner',
        }),
      ];
  }
};
